import { render, staticRenderFns } from "./PopupQualityPlan.vue?vue&type=template&id=12866f04"
import script from "./PopupQualityPlan.vue?vue&type=script&lang=js"
export * from "./PopupQualityPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports